// 1. Variables privadas del módulo (están seguras aquí y no colisionan globalmente)
let _needsRender = true; 
let _surfaceY = null; // Variable interna para la altura del agua
let aguaBack = null;
let terrainMesh =null;
let scene =null;
let camera = null;
let controls = null;

export const renderManager = {
  // --- CONTROL DEL RENDER ---
  get needsRender() {
    return _needsRender;
  },
  set needsRender(value) {
    if (typeof value === 'boolean') {
      _needsRender = value;
    } else {
      console.error("Error: needsRender solo acepta valores booleanos.");
    }
  },

  // --- CONTROL DE LA SUPERFICIE DEL AGUA (surfaceY) ---
  get surfaceY() {
    return _surfaceY;
  },
  set surfaceY(value) {
    if (value === null || (typeof value === 'number' && !isNaN(value))) {
      _surfaceY = value;
    } else {
      console.error("Error: surfaceY solo acepta números o null.");
    }
  },



  // --- CONTROL DE AGUABACK ---
  get aguaBack() {
    return aguaBack;
  },
  set aguaBack(value) {
    aguaBack = value;
  },



 get terrainMesh(){
 	return terrainMesh;
 },
 set terrainMesh(value) {
    terrainMesh = value;
  },



 get scene(){
 	return scene;
 },
 set scene(value) {
    scene = value;
  },



 get camera(){
 	return camera;
 },
 set camera(value) {
    camera = value;
  },



 get controls(){
  return controls;
 },
 set controls(value) {
    controls = value;
  }



};